import styles from './Category.module.scss';

const Category = ({ category }: { category: string }) => (
  <div className={styles.postCategory}>
    <span>{category}</span>
  </div>
);

export default Category;
